/*  Standard usage:

  ngOnInit() {
    this.dialog.open(WarehouseSelectionDialogComponent).afterClosed().subscribe(warehouseID => {
      if (!warehouseID) { this.router.navigate(['/']); return; }

      // use warehouseID;
    });
  }
  
*/

import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  templateUrl: './warehouse-selection-dialog.component.html',
  styleUrls: ['./warehouse-selection-dialog.component.css']
})
export class WarehouseSelectionDialogComponent {
  warehouseID = new FormControl();

  constructor(
    private dialogRef: MatDialogRef<WarehouseSelectionDialogComponent>
  ) { }


  closeWithWarehouseID() {
    this.dialogRef.close(this.warehouseID.value);
  }
}
